import React, { useEffect, useState } from 'react'
import constants from '../constants'
import App from './app'
const webglDetect = require('webgl-detect')

const Wrapper = () => {
  const [isReady, setIsReady] = useState(false)
  useEffect(() => {
    window.webglAvailable = false
    if (webglDetect) window.webglAvailable = true
    // window.webglAvailable = false
    window.isMobile = window.innerWidth <= constants.MQ_LARGE
    setIsReady(true)
  })
  return (
    <div>
      { isReady && <App /> }
    </div>
  )
}

export default Wrapper